import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { getListingMedia } from "@/utils/constants";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function APlusVenueSpotlight() {
  const [venues, setVenues] = useState([]);
  useEffect(() => {
    axios.get(`${API}/listings`, { params: { page: 1, limit: 4, grade: "A+", sort: "verified" } })
      .then((response) => setVenues(response.data.items || []))
      .catch(() => setVenues([]));
  }, []);
  if (!venues.length) return null;
  return (
    <section className="iw-grid-bg-dark bg-[#081334] text-white border-b border-white/10" data-testid="a-plus-spotlight">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-9">
        <div className="flex items-end justify-between gap-6 flex-wrap mb-6">
          <div><p className="font-mono text-[10px] uppercase font-bold text-white/55">§ Recently verified A+ venues</p><h2 className="font-heading text-2xl sm:text-3xl text-white font-semibold mt-1">Exceptional places, with the reasons shown.</h2></div>
          <Link to="/?grade=A%2B" className="font-mono text-[10px] uppercase font-semibold text-[#F45B63]" data-testid="a-plus-view-all">View all A+ venues →</Link>
        </div>
        <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-px bg-white/20 border border-white/20">
          {venues.map((venue) => {
            const media = getListingMedia(venue);
            return <Link key={venue.id} to={`/listing/${venue.id}`} className="bg-[#081334] hover:bg-white/[0.06] p-4 transition-colors min-w-0" data-testid={`a-plus-venue-${venue.id}`}>
              <div className="relative"><img src={media.src} alt={media.verified ? `${venue.name} owner photo` : `${venue.categoryRaw || venue.category} category image`} className="w-full aspect-[16/9] object-cover border border-white/20" loading="lazy" /><span className="absolute bottom-2 left-2 bg-white text-navy text-[9px] uppercase font-mono font-bold px-2 py-1" data-testid={`a-plus-image-source-${venue.id}`}>{media.label}</span></div>
              <div className="flex items-start justify-between gap-3 mt-4"><h3 className="font-heading text-lg text-white font-semibold leading-tight">{venue.name}</h3><span className="bg-white text-navy px-2 py-1 text-xs font-mono font-bold flex-shrink-0">A+</span></div>
              <p className="font-body text-xs text-white/65 mt-1">{venue.city || venue.zone}</p>
              <p className="font-body text-[10px] uppercase tracking-widest font-bold text-white/60 mt-4">Why it earned A+</p>
              <ul className="mt-2 space-y-1">{(venue.gradeReasons || ["Top community wellness grade"]).map((reason) => <li key={reason} className="font-body text-xs text-white/85">— {reason}</li>)}</ul>
            </Link>;
          })}
        </div>
      </div>
    </section>
  );
}